/**
 * Storage Configuration
 *
 * localStorage keys and storage-related constants used by the attribution library.
 * Individual exports enable tree-shaking - only imported constants are bundled.
 * Aggregated STORAGE_CONFIG object provides convenience for tests and non-critical paths.
 *
 * @module config/storage
 */
/**
 * Main attribution data storage key
 * Used to store TuneParamData in localStorage
 */
export const STORAGE_KEY_PARAM_DATA = 'cl_param_data';
/**
 * MapiJS session data storage key
 * Used to check for MapiJS session information
 */
export const STORAGE_KEY_MAPI = 'mapi';
/**
 * Last known referrer storage key
 * Used to track referrer for attribution logic
 */
export const STORAGE_KEY_REFERRER = 'referrer';
/**
 * Aggregated storage configuration object
 *
 * Combines all individual exports into a single object for convenience.
 * Useful for: Tests, documentation, and non-critical paths where tree-shaking isn't essential.
 *
 * For performance-critical code: Use individual exports instead.
 * Example: import {STORAGE_KEY_PARAM_DATA} from './storage.config'
 */
export const STORAGE_CONFIG = {
    keys: {
        paramData: STORAGE_KEY_PARAM_DATA,
        mapi: STORAGE_KEY_MAPI,
        referrer: STORAGE_KEY_REFERRER,
    },
};
